<script>
  import { auth, googleProvider } from '../firebase';
  import { db } from '../firebase';
  import Locations from './Locations.svelte';

  let user = null;
  $: loggedIn = user !== null;

  let URL_BASE = 'https://api.ubibot.com/';
  let locations = [];

  const loginWithGoogle = () => {
    return auth.signInWithPopup(googleProvider);
  };

  const logout = () => auth.signOut();

  const userMapper = (claims) => ({
    id: claims.user_id,
    name: claims.name,
    email: claims.email,
    picture: claims.picture,
  });

  auth.onAuthStateChanged(async (fireUser) => {
    if (fireUser) {
      const token = await fireUser.getIdTokenResult();

      getLocations().then((fireLocations) => {
        fireLocations.forEach((location, i) =>
          loadLocationDevices(location).then((devices) => {
            locations[i] = { ...location, devices };
          })
        );
      });

      user = userMapper(token.claims);
    } else {
      user = null;
    }
  });

  async function getLocations() {
    try {
      let ref = await db.collection('locations');
      let snapshot = await ref.get();
      let docs = snapshot.docs.map((doc) => doc.data());

      return docs;
    } catch (e) {
      throw new Error(e);
    }
  }

  const formatDateTime = (data) => {
    let date = new Date(data);

    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const channelMapper = (data) => {
    let last_values = JSON.parse(data.channel.last_values);

    return {
      last_entry_date: formatDateTime(data.channel.last_entry_date),
      temperatureRefrigerator: last_values.field7,
      temperatureFreezer: last_values.field10 ? last_values.field10 : 'N/A',
    };
  };

  async function loadDevice(device, account_key) {
    const res = await fetch(`${URL_BASE}channels/${device.channel}?account_key=${account_key}`);

    const data = await res.json();

    let dataMapped = channelMapper(data);

    if (data.result == 'success') {
      return { ...device, ...dataMapped };
    } else {
      throw new Error(data.result);
    }
  }

  function loadLocationDevices(location) {
    let promises = [];

    location.devices.forEach((device) => {
      promises.push(loadDevice(device, location.account_key));
    });

    return Promise.all(promises);
  }
</script>

<main>
  {#if loggedIn}
    <nav class="bg-black flex flex-row items-center justify-between">
      <img class="h-8" src="/logo.png" alt="logo" />
      <span class="text-white font-bold text-lg md:text-xl">Centro de monitoreo</span>
      <button type="button" on:click={logout}>Cerrar sesión</button>
    </nav>

    <Locations {locations} />
  {:else}
    <nav class="bg-black flex flex-row items-center justify-center">
      <img class="h-8" src="/logo.png" alt="logo" />
    </nav>

    <div class="m-auto w-max flex flex-col">
      <br />
      <br />
      <h1 class="font-bold text-lg md:text-xl">Bienvenido al Centro de Monitoreo</h1>
      <br />
      <button type="button" on:click={loginWithGoogle}>Iniciar sesión</button>
    </div>
  {/if}
</main>

<style global>
  @tailwind base;
  @tailwind components;
  @tailwind utilities;

  /* main {
    text-align: center;
    padding-bottom: 100px;
  }

  nav {
    background-color: black;
    margin: -8px;
    padding: 8px;
  }

  button {
    background-color: white;
    font-weight: bold;
    font-size: larger;
    border: 1px solid black;
  } */

  button {
    @apply bg-white font-bold text-lg md:text-xl border border-solid border-black p-2;
  }
</style>
